import styled from 'styled-components';

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid ${({ theme }) => theme.colors.brandLight || 'rgba(130, 22, 146, 0.8)'};
  padding-bottom: 0.9375rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.625rem;
  }
`;

export default PageHeader;
